module.exports = __webpack_public_path__ + "img/duke_riley.d9945470.png";